import { throttle } from 'lodash';
import { Mutations } from '@shared/api';
import { getSharedApolloClient } from '@shared/api/client';
import { IS_TYPING_UPDATE_THROTTLE_DURATION } from '@shared/styles';
import { API } from '@shared/types/api';
import { MBChannelTypeUtil } from '../../util/channelType';

// TODO(fant): remove this after shared keyboard rewrite.
export function updateDraftContent(content: string, channelSlug: string, isTyping: boolean = true) {
  return (dispatch: MBDispatch) => {
    dispatch({ type: 'CHAT:UPDATE_DRAFT_CONTENT', value: { content, channelSlug } });
    if (!!content && isTyping) {
      // If we have content, we tell the server that we're typing
      throttledUpdateIsTyping(channelSlug);
    } else {
      // Otherwise, we cancel the update throttle so that we can
      // send the API mutation asap if we start typing (so we don't
      // need to wait for the throttle rate limit)
      throttledUpdateIsTyping.cancel();
    }
  };
}

export function updateDraftUrgent(urgent: boolean, channelSlug: string) {
  return (dispatch: MBDispatch) => {
    dispatch({ type: 'CHAT:UPDATE_DRAFT_URGENT', value: { urgent, channelSlug } });
  };
}

// TODO(fant): remove. Connected to old chat input
export function updateDraftEditing(editing: API.ChatMessageFragment, channelSlug: string) {
  return (dispatch: MBDispatch) => {
    dispatch({ type: 'CHAT:UPDATE_DRAFT_EDITING', value: { channelSlug, editing } });
  };
}

export function addAttachmentToDraft(attachment: API.ChatAttachmentFragment, channelSlug: string) {
  return (dispatch: MBDispatch) => {
    dispatch({ type: 'CHAT:ADD_ATTACHMENT_TO_DRAFT', value: { attachment, channelSlug } });
  };
}

export function removeAttachmentFromDraft(
  attachment: API.ChatAttachmentFragment,
  channelSlug: string,
) {
  return (dispatch: MBDispatch) => {
    dispatch({ type: 'CHAT:REMOVE_ATTACHMENT_FROM_DRAFT', value: { attachment, channelSlug } });
  };
}

export function removeAllAttachmentsFromDraft(channelSlug: string) {
  return (dispatch: MBDispatch) => {
    dispatch({ type: 'CHAT:REMOVE_ALL_ATTACHMENTS_FROM_DRAFT', value: { channelSlug } });
  };
}

export function removeDraft(channelSlug: string) {
  return (dispatch: MBDispatch) => {
    dispatch({ type: 'CHAT:REMOVE_DRAFT', value: { channelSlug } });
    // Cancel is typing updates when we remove a draft (similar to content being emptied)
    throttledUpdateIsTyping.cancel();
  };
}

async function updateIsTyping(channelSlug: string) {
  // we don't support isTyping for shift or task change threads
  const isThread = MBChannelTypeUtil.isThread(channelSlug);
  if (!isThread) {
    const apolloClient = getSharedApolloClient();
    await apolloClient.mutate<API.UpdateIsTypingMutation>({
      mutation: Mutations.chat.updateIsTyping,
      variables: { channelSlug },
    });
  }
}

export const throttledUpdateIsTyping = throttle(updateIsTyping, IS_TYPING_UPDATE_THROTTLE_DURATION);

export function startEditingMessage(message: API.ChatMessageFragment, draftId: string) {
  return (dispatch: MBDispatch) => {
    dispatch({ type: 'CHAT:UPDATE_EDITING_MESSAGE', value: { draftId, message } });
  };
}

export function endEditingMessage(draftId: string) {
  return (dispatch: MBDispatch) => {
    dispatch({ type: 'CHAT:UPDATE_EDITING_MESSAGE', value: { draftId, message: undefined } });
  };
}
